import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-8 pb-10 sm:pt-12 sm:pb-16 items-center justify-center overflow-hidden bg-bg-main" data-id="element-116">
      {/* Brand */}
      <span className="relative inline-block font-serif font-black text-lg sm:text-2xl tracking-tight text-primary mb-3 sm:mb-4" data-id="element-117">
        EDUFIS<span className="text-text-main" data-id="element-118"> PRONTO</span>
      </span>

      {/* Main headline */}
      <h1 className="relative font-serif font-black max-w-4xl text-[30px] leading-[1.12] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-3 sm:mb-5 tracking-tight text-text-main" data-id="element-119">
        Risolvi un intero anno di Educazione Fisica in soli{' '}
        <span className="text-primary italic font-serif" data-id="element-120">5 minuti</span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-sm sm:text-lg font-medium leading-relaxed mb-5 sm:mb-7 max-w-2xl mx-auto text-text-sec" data-id="element-121">
        Oltre 2.000 insegnanti in tutta Italia hanno smesso di improvvisare.
        Arriva in palestra con tutto pronto per insegnare, motivare e far
        muovere i tuoi alunni.
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[380px] sm:max-w-[620px] md:max-w-[740px] mx-auto mb-6 sm:mb-8" data-id="element-122">
        <img src="https://cdn.magicpatterns.com/uploads/k2PuDt2WEq8iqbty1cCSQF/Diseno-sin-titulo-_98_.webp" alt="EDUFIS PRONTO — Pack digitale con 12 volumi per docenti di Educazione Fisica" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(22,195,74,0.14)]" width={1080} height={680} fetchPriority="high" loading="eager" decoding="async" data-id="element-123" />
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse font-bold text-base sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl transition-colors inline-flex items-center justify-center gap-2 mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white bg-primary hover:bg-primary-hover shadow-[0_10px_30px_-10px_rgba(22,195,74,0.5)]" data-id="element-124">
        <span aria-hidden="true" data-id="element-125">🚀</span>
        VOGLIO IL PACK EDUFIS PRONTO
      </a>

      {/* Trust badges */}
      <p className="text-text-sec text-xs sm:text-sm font-medium flex items-center justify-center gap-x-4 gap-y-2 flex-wrap" data-id="element-126">
        <span className="flex items-center gap-1" data-id="element-127">
          <span aria-hidden="true" data-id="element-128">🔒</span> Pagamento sicuro
        </span>
        <span className="flex items-center gap-1" data-id="element-129">
          <span aria-hidden="true" data-id="element-130">⚡</span> Accesso immediato
        </span>
        <span className="flex items-center gap-1" data-id="element-131">
          <span aria-hidden="true" data-id="element-132">🛡️</span> Garanzia 7 giorni
        </span>
      </p>
    </section>;
}